<app-nav-pages></app-nav-pages>

<main>
  <section
    class="hero-section d-flex justify-content-center align-items-center csr-hero"
  >
    <div class="overlay"></div>
    <iframe
      src="https://www.youtube.com/embed/aSvrqH1FRtA?autoplay=1&mute=1&loop=1&rel=0&fs=0&color=white&controls=0&disablekb=1&playlist=aSvrqH1FRtA"
      width="560"
      height="315"
      title="Inspiring A Better Future: Celebrating Our Past Heroes Who Challenged the Status Quo."
      [frameBorder]="0"
    ></iframe>

    <div class="hero-text text-center d-flex align-items-center flex-column">
      <h4>INSPIRE A BETTER FUTURE</h4>
      <h2>
        ZUMERA VALUE <br />
        CREATION INITIATIVE
      </h2>
      <a
        href="https://www.youtube.com/watch?v=aSvrqH1FRtA"
        class="know-more-btn transparent_btn mt-5"
        ><b>WATCH THE VIDEO</b>
      </a>
    </div>
  </section>

  <section class="brand-wrapper py-5 mt-5">
    <h2 class="text-center welcome_mssg w-50 wo-100 mx-auto">
      Sustainability, Upholding our Continent's Rich Heritage, Encouraging
      Innovation, Value Creation and Grooming the next Generation's Change
      Makers.
    </h2>

    <div
      class="past_heroes position-relative d-flex justify-content-end align-items-center"
    >
      <div class="overlay"></div>
      <div class="past_heroes_content w-50 wo-100 px-3">
        <h2 class="reach_out_zumera z-3 position-relative">
          BE A CHANGE MAKER- INSPIRE A BETTER FUTURE
        </h2>
        <p class="fs-4 fs-p-sm z-3 position-relative">
          ZUMERA Acknowledge and Stand Alongside influential value-driven
          individuals, the change makers, entrepreneurs, comedians, artists, and
          business leaders Committed to a Common Vision, who are dedicated to
          challenging the status quo for a brighter and more innovative tomorrow
          for our Communities.
        </p>
      </div>
    </div>

    <div class="container_bg_img cl-light">
      <div class="overlay"></div>

      <div class="brand_container py-3 d-flex gap-3">
        <div class="statement d-flex flex-column wo-100">
          <h2 class="reach_out_zumera z-3 position-relative">
            REACH-OUT ZUMERA
          </h2>
          <h3 class="statement w-100 z-3 position-relative">
            We Believe In The Potential <br />
            Of Every Human
          </h3>

          <a
            class="know-more-btn mt-5 z-3 position-relative align-self-start d-flex"
            routerLink="/reach-out"
          >
            <div>KNOW MORE</div>
            <!-- <div class="">
              <img src="assets/icons/white_z_arrow.png" alt="img-fluid" class="img-fluid ">
            </div> -->
          </a>
        </div>
      </div>
    </div>
  </section>
</main>

<div class="my-5 d-flex flex-column">
  <p class="quote_3_p text-center">
    NEXT <span class="rdj_bold">&#8594;</span>
  </p>
  <h3 class="mb-3 text-center rdj_bold">LEADERSHIP</h3>
  <a routerLink="/who-we-are/leadership" class="know-more-btn align-self-center"
    >KNOW MORE</a
  >
</div>
<app-footer class="w-100 d-none d-sm-block"></app-footer>
<app-footer-sm class="w-100 d-sm-none"></app-footer-sm>
